import { render, staticRenderFns } from "./TabProducts.vue?vue&type=template&id=b7cee8a6&"
import script from "./TabProducts.vue?vue&type=script&lang=ts&"
export * from "./TabProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b7cee8a6', component.options)
    } else {
      api.reload('b7cee8a6', component.options)
    }
    module.hot.accept("./TabProducts.vue?vue&type=template&id=b7cee8a6&", function () {
      api.rerender('b7cee8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/TabsModals/Products/TabProducts.vue"
export default component.exports